export const sortByCreatedDate = (arr: any[]) => {
  if (!arr?.length) return [];
  return arr.sort((a, b) => {
    return (
      new Date(b.created_at || 0).getTime() -
      new Date(a.created_at || 0).getTime()
    );
  });
};
